var T = Object.defineProperty;
var x = (y, t, e) => t in y ? T(y, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : y[t] = e;
var L = (y, t, e) => x(y, typeof t != "symbol" ? t + "" : t, e);
class q {
  constructor(t) {
    L(this, "strToUniqueId", /* @__PURE__ */ new Map());
    L(this, "uniqueIdToStr", /* @__PURE__ */ new Map());
    L(this, "currentUniqueId", 0);
    if (t)
      for (const [e, s] of t) {
        if (!e || e.trim() === "") {
          console.warn(`Skipping empty string with id ${s} during deserialization`);
          continue;
        }
        this.strToUniqueId.set(e, s), this.uniqueIdToStr.set(s, e), this.currentUniqueId = Math.max(this.currentUniqueId, s + 1);
      }
  }
  id(t) {
    if (!t || t.trim() === "")
      throw new Error("Cannot store empty or whitespace-only strings");
    const e = this.strToUniqueId.get(t);
    if (e !== void 0)
      return e;
    const s = this.currentUniqueId++;
    return this.strToUniqueId.set(t, s), this.uniqueIdToStr.set(s, t), s;
  }
  str(t) {
    const e = this.uniqueIdToStr.get(t);
    if (!e)
      throw new Error("pub: invalid id " + t);
    return e;
  }
  has(t) {
    return this.strToUniqueId.has(t);
  }
  serialize(t) {
    return t ? Array.from(this.uniqueIdToStr.entries()).filter(([e]) => t.has(e)).map(([e, s]) => [s, e]) : Array.from(this.strToUniqueId.entries());
  }
  *[Symbol.iterator]() {
    yield* this.uniqueIdToStr.entries();
  }
  remove(t) {
    const e = this.uniqueIdToStr.get(t);
    e !== void 0 && (this.uniqueIdToStr.delete(t), this.strToUniqueId.delete(e));
  }
}
const v = /^[0-9a-fA-F]{64}$/, R = 2;
function N(y) {
  const t = y;
  return {
    ids: t.ids,
    followedByUser: t.followedByUser,
    followListCreatedAt: t.followListCreatedAt,
    mutedByUser: t.mutedByUser,
    muteListCreatedAt: t.muteListCreatedAt
  };
}
function P(y) {
  if (!/^[0-9a-fA-F]+$/.test(y))
    throw new Error(`Invalid hex string: ${y}`);
  if (y.length % 2 !== 0)
    throw new Error(`Hex string must have even length: ${y}`);
  const t = new Uint8Array(y.length / 2);
  for (let e = 0; e < y.length; e += 2)
    t[e / 2] = parseInt(y.substr(e, 2), 16);
  return t;
}
function k(y) {
  return Array.from(y).map((t) => t.toString(16).padStart(2, "0")).join("");
}
function F(y) {
  const t = [];
  let e = y;
  for (; e >= 128; )
    t.push(e & 127 | 128), e >>>= 7;
  return t.push(e & 127), new Uint8Array(t);
}
async function* z(y) {
  const { ids: t, followedByUser: e, followListCreatedAt: s, mutedByUser: o, muteListCreatedAt: r } = N(y), n = Array.from(t).filter((u) => {
    const [, a] = u;
    return !a || a.trim() === "" || !/^[0-9a-fA-F]{64}$/.test(a) ? (console.warn(`Skipping invalid public key: "${a}"`), !1) : !0;
  });
  yield F(R), yield F(n.length);
  for (const [u, a] of n) {
    const c = P(a);
    yield F(u), yield c, yield new Uint8Array(0);
  }
  const l = Array.from(e.entries()).filter((u) => s.has(u[0]));
  yield F(l.length);
  for (const [u, a] of l) {
    const c = s.get(u) || 0;
    yield F(u), yield F(c), yield F(a.size);
    for (const m of a)
      yield F(m);
    yield new Uint8Array(0);
  }
  const d = Array.from(o.entries()).filter((u) => r.has(u[0]));
  yield F(d.length);
  for (const [u, a] of d) {
    const c = r.get(u) || 0;
    yield F(u), yield F(c), yield F(a.size);
    for (const m of a)
      yield F(m);
    yield new Uint8Array(0);
  }
}
async function $(y) {
  return new Promise((t, e) => {
    const s = [];
    let o = 0;
    queueMicrotask(async () => {
      try {
        for await (const d of z(y))
          d.length > 0 && (s.push(d), o += d.length);
        const n = new Uint8Array(o);
        let l = 0;
        for (const d of s)
          n.set(d, l), l += d.length;
        t(n);
      } catch (n) {
        e(n);
      }
    });
  });
}
async function G(y, t) {
  return new Promise((e, s) => {
    let o = 0;
    function r(l) {
      if (o + l > t.length)
        throw new Error("Unexpected end of data");
      const d = t.slice(o, o + l);
      return o += l, d;
    }
    function n() {
      let l = 0, d = 0;
      for (; ; ) {
        const a = r(1)[0];
        if (l |= (a & 127) << d, (a & 128) === 0)
          break;
        d += 7;
      }
      return l;
    }
    try {
      n();
      const l = n(), d = [];
      for (let i = 0; i < l; i++) {
        const h = n(), f = r(32), w = k(f);
        d.push([w, h]);
      }
      const u = new b(y, { uniqueIds: d, followLists: [], muteLists: [] }), a = n(), c = [];
      for (let i = 0; i < a; i++) {
        const h = n(), f = n(), w = n(), B = [];
        for (let U = 0; U < w; U++)
          B.push(n());
        c.push([h, B, f]);
      }
      const m = n(), p = [];
      for (let i = 0; i < m; i++) {
        const h = n(), f = n(), w = n(), B = [];
        for (let U = 0; U < w; U++)
          B.push(n());
        p.push([h, B, f]);
      }
      const C = () => {
        let i = 0;
        const h = () => {
          if (i >= c.length) {
            g();
            return;
          }
          const [f, w, B] = c[i], U = u;
          U.followListCreatedAt.set(f, B);
          for (const A of w)
            U.privateAddFollower(A, f);
          i++, queueMicrotask(h);
        };
        queueMicrotask(h);
      }, g = () => {
        let i = 0;
        const h = () => {
          var A;
          if (i >= p.length) {
            u.recalculateFollowDistances().then(() => {
              e(u);
            }).catch(s);
            return;
          }
          const [f, w, B] = p[i], U = u;
          U.muteListCreatedAt.set(f, B), U.mutedByUser.set(f, new Set(w));
          for (const S of w)
            U.userMutedBy.has(S) || U.userMutedBy.set(S, /* @__PURE__ */ new Set()), (A = U.userMutedBy.get(S)) == null || A.add(f);
          i++, queueMicrotask(h);
        };
        queueMicrotask(h);
      };
      C();
    } catch (l) {
      s(l);
    }
  });
}
async function j(y, t) {
  const e = t.getReader();
  let s = new Uint8Array(0);
  async function o(g) {
    for (; s.length < g; ) {
      const { value: h, done: f } = await e.read();
      if (f) throw new Error("Unexpected end of stream");
      const w = new Uint8Array(s.length + h.length);
      w.set(s), w.set(h, s.length), s = w;
    }
    const i = s.slice(0, g);
    return s = s.slice(g), i;
  }
  async function r() {
    let g = 0, i = 0;
    for (; ; ) {
      const f = (await o(1))[0];
      if (g |= (f & 127) << i, (f & 128) === 0)
        break;
      i += 7;
    }
    return g;
  }
  await r();
  const n = await r(), l = [];
  for (let g = 0; g < n; g++) {
    const i = await r(), h = await o(32), f = k(h);
    l.push([f, i]);
  }
  const d = new b(y, { uniqueIds: l, followLists: [], muteLists: [] }), u = await r(), a = [];
  for (let g = 0; g < u; g++) {
    const i = await r(), h = await r(), f = await r(), w = [];
    for (let B = 0; B < f; B++)
      w.push(await r());
    a.push([i, w, h]);
  }
  const c = await r(), m = [];
  for (let g = 0; g < c; g++) {
    const i = await r(), h = await r(), f = await r(), w = [];
    for (let B = 0; B < f; B++)
      w.push(await r());
    m.push([i, w, h]);
  }
  const p = () => new Promise((g) => {
    let i = 0;
    const h = () => {
      if (i >= a.length) {
        g();
        return;
      }
      const [f, w, B] = a[i], U = d;
      U.followListCreatedAt.set(f, B);
      for (const A of w)
        U.privateAddFollower(A, f);
      i++, queueMicrotask(h);
    };
    queueMicrotask(h);
  }), C = () => new Promise((g) => {
    let i = 0;
    const h = () => {
      var A;
      if (i >= m.length) {
        g();
        return;
      }
      const [f, w, B] = m[i], U = d;
      U.muteListCreatedAt.set(f, B), U.mutedByUser.set(f, new Set(w));
      for (const S of w)
        U.userMutedBy.has(S) || U.userMutedBy.set(S, /* @__PURE__ */ new Set()), (A = U.userMutedBy.get(S)) == null || A.add(f);
      i++, queueMicrotask(h);
    };
    queueMicrotask(h);
  });
  return await p(), await C(), await d.recalculateFollowDistances(), d;
}
class b {
  constructor(t, e) {
    L(this, "root");
    L(this, "followDistanceByUser", /* @__PURE__ */ new Map());
    L(this, "usersByFollowDistance", /* @__PURE__ */ new Map());
    L(this, "followedByUser", /* @__PURE__ */ new Map());
    L(this, "followersByUser", /* @__PURE__ */ new Map());
    L(this, "followListCreatedAt", /* @__PURE__ */ new Map());
    L(this, "mutedByUser", /* @__PURE__ */ new Map());
    L(this, "userMutedBy", /* @__PURE__ */ new Map());
    L(this, "muteListCreatedAt", /* @__PURE__ */ new Map());
    L(this, "ids", new q());
    this.ids = new q(e && e.uniqueIds), this.root = this.id(t), this.followDistanceByUser.set(this.root, 0), this.usersByFollowDistance.set(0, /* @__PURE__ */ new Set([this.root])), e && this.deserialize(e);
  }
  id(t) {
    return this.ids.id(t);
  }
  str(t) {
    return this.ids.str(t);
  }
  getRoot() {
    return this.str(this.root);
  }
  setRoot(t) {
    const e = this.id(t);
    return e === this.root ? Promise.resolve() : (this.root = e, this.recalculateFollowDistances());
  }
  recalculateFollowDistances() {
    return new Promise((t) => {
      this.followDistanceByUser.clear(), this.usersByFollowDistance.clear(), this.followDistanceByUser.set(this.root, 0), this.usersByFollowDistance.set(0, /* @__PURE__ */ new Set([this.root]));
      const e = [this.root];
      let s = 0;
      const o = () => {
        if (e.length === 0) {
          console.log(`Finished recalculating follow distances. Processed ${s} users.`), t();
          return;
        }
        const r = e.shift(), n = this.followDistanceByUser.get(r), l = this.followedByUser.get(r) || /* @__PURE__ */ new Set();
        for (const d of l)
          if (!this.followDistanceByUser.has(d)) {
            const u = n + 1;
            this.followDistanceByUser.set(d, u), this.usersByFollowDistance.has(u) || this.usersByFollowDistance.set(u, /* @__PURE__ */ new Set()), this.usersByFollowDistance.get(u).add(d), e.push(d);
          }
        s++, s % 1e4 === 0 && console.log(`Recalculating follow distances: ${s} users processed, ${e.length} remaining`), queueMicrotask(o);
      };
      queueMicrotask(o);
    });
  }
  handleEvent(t) {
    const e = (Array.isArray(t) ? t : [t]).filter((s) => [3, 1e4].includes(s.kind));
    for (const s of e) {
      const o = s.created_at;
      if (o > Math.floor(Date.now() / 1e3) + 10 * 60) {
        console.debug("event.created_at more than 10 minutes in the future", s);
        continue;
      }
      const r = this.id(s.pubkey);
      s.kind === 3 ? this.handleFollowList(s, r, o) : s.kind === 1e4 && this.handleMuteList(s, r, o);
    }
  }
  handleFollowList(t, e, s) {
    const o = this.followListCreatedAt.get(e);
    if (o && s <= o)
      return;
    this.followListCreatedAt.set(e, s);
    const r = /* @__PURE__ */ new Set();
    for (const l of t.tags)
      if (l[0] === "p") {
        if (!v.test(l[1]))
          continue;
        const d = this.id(l[1]);
        d !== e && r.add(d);
      }
    const n = this.followedByUser.get(e) || /* @__PURE__ */ new Set();
    for (const l of n)
      r.has(l) || this.privateRemoveFollower(l, e);
    for (const l of r)
      this.privateAddFollower(l, e);
  }
  handleMuteList(t, e, s) {
    var l, d, u, a;
    const o = this.muteListCreatedAt.get(e);
    if (o && s <= o)
      return;
    this.muteListCreatedAt.set(e, s);
    const r = /* @__PURE__ */ new Set();
    for (const c of t.tags)
      if (c[0] === "p") {
        if (!v.test(c[1]))
          continue;
        const m = this.id(c[1]);
        m !== e && r.add(m);
      }
    const n = this.mutedByUser.get(e) || /* @__PURE__ */ new Set();
    for (const c of n)
      r.has(c) || ((l = this.mutedByUser.get(e)) == null || l.delete(c), (d = this.userMutedBy.get(c)) == null || d.delete(e));
    for (const c of r)
      this.mutedByUser.has(e) || this.mutedByUser.set(e, /* @__PURE__ */ new Set()), (u = this.mutedByUser.get(e)) == null || u.add(c), this.userMutedBy.has(c) || this.userMutedBy.set(c, /* @__PURE__ */ new Set()), (a = this.userMutedBy.get(c)) == null || a.add(e);
  }
  isFollowing(t, e) {
    var r;
    const s = this.id(e), o = this.id(t);
    return !!((r = this.followedByUser.get(o)) != null && r.has(s));
  }
  getFollowDistance(t) {
    const e = this.followDistanceByUser.get(this.id(t));
    return e === void 0 ? 1e3 : e;
  }
  addUserByFollowDistance(t, e) {
    var s, o;
    this.usersByFollowDistance.has(t) || this.usersByFollowDistance.set(t, /* @__PURE__ */ new Set()), (s = this.usersByFollowDistance.get(t)) == null || s.add(e);
    for (const r of this.usersByFollowDistance.keys())
      r > t && ((o = this.usersByFollowDistance.get(r)) == null || o.delete(e));
  }
  privateAddFollower(t, e) {
    var s, o;
    if (typeof t != "number" || typeof e != "number")
      throw new Error("Invalid user id");
    if (this.followersByUser.has(t) || this.followersByUser.set(t, /* @__PURE__ */ new Set()), (s = this.followersByUser.get(t)) == null || s.add(e), this.followedByUser.has(e) || this.followedByUser.set(e, /* @__PURE__ */ new Set()), t !== this.root) {
      let r;
      if (e === this.root)
        r = 1, this.addUserByFollowDistance(r, t), this.followDistanceByUser.set(t, r);
      else {
        const n = this.followDistanceByUser.get(t), l = this.followDistanceByUser.get(e);
        r = l && l + 1, (n === void 0 || r && r < n) && (this.followDistanceByUser.set(t, r), this.addUserByFollowDistance(r, t));
      }
    }
    (o = this.followedByUser.get(e)) == null || o.add(t);
  }
  addFollower(t, e) {
    this.privateAddFollower(this.id(e), this.id(t));
  }
  removeFollower(t, e) {
    this.privateRemoveFollower(this.id(e), this.id(t));
  }
  privateRemoveFollower(t, e) {
    var o, r;
    if ((o = this.followersByUser.get(t)) == null || o.delete(e), (r = this.followedByUser.get(e)) == null || r.delete(t), t === this.root)
      return;
    let s = 1 / 0;
    for (const n of this.followersByUser.get(t) || []) {
      const l = this.followDistanceByUser.get(n);
      l !== void 0 && l + 1 < s && (s = l + 1);
    }
    s === 1 / 0 ? this.followDistanceByUser.delete(t) : this.followDistanceByUser.set(t, s);
  }
  followerCount(t) {
    var s;
    const e = this.id(t);
    return ((s = this.followersByUser.get(e)) == null ? void 0 : s.size) ?? 0;
  }
  followedByFriendsCount(t) {
    var o;
    let e = 0;
    const s = this.id(t);
    for (const r of this.followersByUser.get(s) ?? [])
      (o = this.followedByUser.get(this.root)) != null && o.has(r) && e++;
    return e;
  }
  mutedByFriendsCount(t) {
    var o;
    let e = 0;
    const s = this.id(t);
    for (const r of this.userMutedBy.get(s) ?? [])
      (o = this.followedByUser.get(this.root)) != null && o.has(r) && e++;
    return e;
  }
  size() {
    let t = 0, e = 0;
    const s = {};
    for (const o of this.followedByUser.values())
      t += o.size;
    for (const o of this.mutedByUser.values())
      e += o.size;
    for (const [o, r] of this.usersByFollowDistance.entries())
      s[o] = r.size;
    return {
      users: this.followDistanceByUser.size,
      follows: t,
      mutes: e,
      sizeByDistance: s
    };
  }
  followedByFriends(t) {
    var o;
    const e = this.id(t), s = /* @__PURE__ */ new Set();
    for (const r of this.followersByUser.get(e) ?? [])
      (o = this.followedByUser.get(this.root)) != null && o.has(r) && s.add(this.str(r));
    return s;
  }
  getFollowedByUser(t, e = !1) {
    const s = this.id(t), o = /* @__PURE__ */ new Set();
    for (const r of this.followedByUser.get(s) || [])
      o.add(this.str(r));
    return e && o.add(t), o;
  }
  getFollowersByUser(t) {
    const e = this.id(t), s = /* @__PURE__ */ new Set();
    for (const o of this.followersByUser.get(e) || [])
      s.add(this.str(o));
    return s;
  }
  serialize(t) {
    return t ? this.serializeWithSizeLimit(t) : this.serializeWithoutSizeLimit();
  }
  serializeWithoutSizeLimit() {
    return new Promise((t) => {
      const e = [], s = [], o = /* @__PURE__ */ new Set(), r = (c) => {
        o.has(c) || o.add(c);
      }, n = (c, m, p, C) => {
        m.length !== 0 && (r(c), m.forEach(r), C ? e.push([c, m, p]) : s.push([c, m, p]));
      }, l = /* @__PURE__ */ new Set();
      for (const [c] of this.followedByUser)
        l.add(c);
      for (const [c] of this.mutedByUser)
        l.add(c);
      const d = Array.from(l);
      let u = 0;
      const a = () => {
        if (u >= d.length) {
          t({
            followLists: e,
            uniqueIds: this.ids.serialize(o),
            muteLists: s
          });
          return;
        }
        const c = d[u], m = this.followedByUser.get(c), p = this.followListCreatedAt.get(c);
        m && p && n(c, Array.from(m), p, !0);
        const C = this.mutedByUser.get(c), g = this.muteListCreatedAt.get(c);
        C && g && n(c, Array.from(C), g, !1), u++, queueMicrotask(a);
      };
      queueMicrotask(a);
    });
  }
  serializeWithSizeLimit(t) {
    return new Promise((e) => {
      const s = [], o = [], r = /* @__PURE__ */ new Set(), n = (i) => i === 0 ? 1 : Math.floor(Math.log10(i)) + 1, l = (i, h) => (h ? 1 : 2) + 64 + 2 + n(i);
      let d = 48, u = 0;
      const a = (i) => r.has(i) ? 0 : (r.add(i), u++, l(i, u === 1)), c = (i, h, f, w) => {
        const B = a(i);
        let A = ((w ? s.length === 0 : o.length === 0) ? 1 : 2) + // '[' or ',['
        n(i) + 1 + // user and comma
        1 + // '[' for nested id array
        1 + // ']' empty array (will grow)
        1 + // comma
        n(f) + 1;
        const S = [];
        for (const I of h) {
          const D = (S.length ? 1 : 0) + n(I), M = a(I), E = D + M;
          if (d + A + E > t)
            break;
          S.push(I), A += D, d += M;
        }
        S.length !== 0 && (d += A + B, w ? s.push([i, S, f]) : o.push([i, S, f]));
      }, m = /* @__PURE__ */ new Set();
      for (const [i] of this.followedByUser)
        m.add(i);
      for (const [i] of this.mutedByUser)
        m.add(i);
      const p = Array.from(m);
      let C = 0;
      const g = () => {
        if (C >= p.length || d >= t) {
          e({
            followLists: s,
            uniqueIds: this.ids.serialize(r),
            muteLists: o
          });
          return;
        }
        const i = p[C], h = this.followedByUser.get(i), f = this.followListCreatedAt.get(i);
        h && f && c(i, Array.from(h), f, !0);
        const w = this.mutedByUser.get(i), B = this.muteListCreatedAt.get(i);
        w && B && c(i, Array.from(w), B, !1), C++, queueMicrotask(g);
      };
      queueMicrotask(g);
    });
  }
  deserialize(t) {
    var r, n;
    const { followLists: e, muteLists: s } = t, o = (r = e[0]) == null ? void 0 : r[0];
    for (const [l, d, u] of e) {
      for (const a of d)
        this.privateAddFollower(a, l);
      this.followListCreatedAt.set(l, u ?? 0);
    }
    if (s)
      for (const [l, d, u] of s) {
        this.mutedByUser.set(l, new Set(d));
        for (const a of d)
          this.userMutedBy.has(a) || this.userMutedBy.set(a, /* @__PURE__ */ new Set()), (n = this.userMutedBy.get(a)) == null || n.add(l);
        this.muteListCreatedAt.set(l, u ?? 0);
      }
    o !== this.root && this.recalculateFollowDistances().catch(console.error);
  }
  getUsersByFollowDistance(t) {
    const e = this.usersByFollowDistance.get(t) || /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
    for (const o of e)
      s.add(this.str(o));
    return s;
  }
  getFollowListCreatedAt(t) {
    return this.followListCreatedAt.get(this.id(t));
  }
  merge(t) {
    return new Promise((e) => {
      console.log("size before merge", this.size()), console.time("merge graph");
      const s = Array.from(t);
      let o = 0;
      const r = () => {
        if (o >= s.length) {
          this.recalculateFollowDistances().then(() => {
            console.timeEnd("merge graph"), console.log("size after merge", this.size()), e();
          });
          return;
        }
        const n = s[o];
        this.mergeUserLists(
          n,
          this.followListCreatedAt,
          t.followListCreatedAt,
          this.followedByUser,
          t.followedByUser
        ), this.mergeUserLists(
          n,
          this.muteListCreatedAt,
          t.muteListCreatedAt,
          this.mutedByUser,
          t.mutedByUser
        ), o++, queueMicrotask(r);
      };
      queueMicrotask(r);
    });
  }
  mergeUserLists(t, e, s, o, r) {
    const n = this.id(t), l = e.get(n), d = s.get(n);
    if (!l || d && l < d) {
      const u = r.get(n) || /* @__PURE__ */ new Set(), a = o.get(n) || /* @__PURE__ */ new Set();
      for (const c of u)
        a.has(c) || (o.has(n) || o.set(n, /* @__PURE__ */ new Set()), o.get(n).add(c));
      for (const c of a)
        u.has(c) || o.get(n).delete(c);
      e.set(n, d ?? 0);
    }
  }
  *userIterator(t) {
    const e = Array.from(this.usersByFollowDistance.keys()).sort((s, o) => s - o);
    for (const s of e) {
      if (t !== void 0 && s > t)
        break;
      const o = this.usersByFollowDistance.get(s) || /* @__PURE__ */ new Set();
      for (const r of o)
        yield this.str(r);
    }
  }
  [Symbol.iterator]() {
    return this.userIterator();
  }
  getMutedByUser(t) {
    const e = this.id(t), s = /* @__PURE__ */ new Set();
    for (const o of this.mutedByUser.get(e) || [])
      s.add(this.str(o));
    return s;
  }
  getUserMutedBy(t) {
    const e = this.id(t), s = /* @__PURE__ */ new Set();
    for (const o of this.userMutedBy.get(e) || [])
      s.add(this.str(o));
    return s;
  }
  // follower and muter counts by distance
  stats(t) {
    const e = {}, s = this.id(t);
    for (const o of this.followersByUser.get(s) || []) {
      const r = this.followDistanceByUser.get(o);
      r !== void 0 && (e[r] || (e[r] = { followers: 0, muters: 0 }), e[r].followers++);
    }
    for (const o of this.userMutedBy.get(s) || []) {
      const r = this.followDistanceByUser.get(o);
      r !== void 0 && (e[r] || (e[r] = { followers: 0, muters: 0 }), e[r].muters++);
    }
    return e;
  }
  removeMutedNotFollowedUsers() {
    const t = /* @__PURE__ */ new Set();
    for (const [e, s] of this.userMutedBy.entries())
      (this.followersByUser.get(e) || /* @__PURE__ */ new Set()).size === 0 && s.size > 0 && t.add(e);
    for (const e of t)
      this.removeUserById(e);
    return t.size;
  }
  removeUserById(t) {
    this.ids.remove(t), this.followDistanceByUser.delete(t), this.followedByUser.delete(t), this.followersByUser.delete(t), this.followListCreatedAt.delete(t), this.mutedByUser.delete(t), this.userMutedBy.delete(t), this.muteListCreatedAt.delete(t), this.usersByFollowDistance.forEach((e) => e.delete(t)), this.followedByUser.forEach((e) => e.delete(t)), this.followersByUser.forEach((e) => e.delete(t)), this.mutedByUser.forEach((e) => e.delete(t)), this.userMutedBy.forEach((e) => e.delete(t));
  }
  toBinaryChunks() {
    return z(this);
  }
  toBinary() {
    return $(this);
  }
  static fromBinary(t, e) {
    return G(t, e);
  }
  static fromBinaryStream(t, e) {
    return j(t, e);
  }
}
export {
  b as SocialGraph,
  q as UniqueIds
};
